<template>
  <div>
    <div v-if="packagePlansParam.init === 1">
      <message :messages="messages"></message>
      <div class="elevation-1">
        <table class="v-datatable v-table theme--light planTable">
          <thead class="planHeader">
            <tr>
              <th class="limitTxtHeader">
                <div class="planHeaderCol">
                  <!-- Reserved for Limit Text-->
                </div>
              </th>
              <th>
                <div class="planHeaderCol text-xs-center">
                  <div class="ribbon" v-if="$store.state.agency.quotation.commonInfo.premium.discPct && $store.state.agency.quotation.commonInfo.premium.discPct > 0">
                    <span class="ribbontitle">{{$store.state.agency.quotation.commonInfo.premium.discPct}}% OFF!</span>
                  </div>
                  <div class="planTitle">
                    {{plan.planDesc}}
                  </div>
                  <div class="mt-2">
                    <span class="planCurr primary--text">{{currPrefix}}</span>
                    <span class="planPrice primary--text">{{formatDisplayNumber($store.state.agency.quotation.commonInfo.premium.premiumPayable)}}</span>
                  </div>
                  <v-btn color="primary" @click.prevent="doProceed" :loading="packagePlansParam.init === 0" :disabled="packagePlansParam.init === 2">
                    Proceed
                    <v-icon right>mdi-chevron-right</v-icon>
                  </v-btn>
                </div>
              </th>
              <th class="planAction">
                <div class="planHeaderCol">
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="planBody">
            <tr v-for="limit in limitsText" :key="limit.value" :class="limit.main? 'titleRow' : ''">
              <td>
                <div class="planCol">
                  <span v-html="formatHtml(limit.label)"></span>
                </div>
              </td>
              <td class="text-xs-center">
                <div class="planCol">
                  <template v-if="plan.limits[limit.value]">
                    <template v-if="plan.limits[limit.value].strValue">
                      <span>{{plan.limits[limit.value].strValue}}</span>
                    </template>
                    <template v-else-if="plan.limits[limit.value].uomUN && plan.limits[limit.value].uomUN !== ''">
                      <span>{{getUomUN(plan.limits[limit.value].uomUN)}}</span>
                    </template>
                    <template v-else-if="siAdjustment[limit.value]">
                      <!-- show adjustment value if available -->
                      <span class="error--text" v-if="plan.limits[limit.value].maxSI < siAdjustment[limit.value] ">
                        <v-icon color="error">
                          mdi-alert-circle-outline
                        </v-icon>
                        <span v-if="plan.limits[limit.value].isSI">{{currPrefix}}</span>
                        <span>{{formatDisplayNumber(siAdjustment[limit.value])}}</span>
                      </span>
                      <span v-else-if="plan.limits[limit.value].isSI">
                        <span>{{currPrefix}}</span>
                        <span>{{formatDisplayNumber(siAdjustment[limit.value])}}</span>
                      </span>
                      <span v-else>
                        <span>{{formatDisplayNumber(siAdjustment[limit.value], 0)}}</span>
                      </span>
                    </template>
                    <template v-else>
                      <template v-if="plan.limits[limit.value].uomAmt">
                        <span v-if="plan.limits[limit.value].isSI">
                          <span>{{currPrefix}}</span>
                          <span>{{formatDisplayNumber(plan.limits[limit.value].uomAmt)}}</span>
                        </span>
                        <span v-else>
                          <span>{{formatDisplayNumber(plan.limits[limit.value].uomAmt, 0)}}</span>
                        </span>
                      </template>
                      <template v-else>
                        <span v-if="plan.limits[limit.value].isSI">
                          <span>{{currPrefix + '0'}}</span>
                        </span>
                        <span v-else>
                          <span>0</span>
                        </span>
                      </template>
                    </template>
                  </template>
                </div>
              </td>
              <td class="text-xs-center">
                <div class="planCol" v-if="plan.limits[limit.value] && !plan.limits[limit.value].protSI">
                  <v-icon color="primary" @click="doEdit(limit.value)" :disabled="packagePlansParam.init === 0">
                    mdi-pencil
                  </v-icon>
                </div>
                <div class="planCol" v-else>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <v-dialog v-model="adjDialog" max-width="600px" lazy>
        <v-card>
          <v-card-title>
            <span class="headline">Adjustment</span>
            <v-spacer></v-spacer>
            <v-btn flat icon @click="adjDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-subheader>
              {{selectedLimitText}}
            </v-subheader>
            <div class="pa-3">
              <v-layout row wrap justify-center align-center>
                <span>Increase: </span>
                <span class="font-weight-bold pr-3">{{formatDisplayNumber(selectedLimits.incSI)}}</span>
                <span>Default: </span>
                <span class="font-weight-bold">{{formatDisplayNumber(selectedLimits.uomAmt)}}</span>
              </v-layout>
            </div>
            <div>
              <v-layout row wrap>
                <v-flex xs2 class="pa-2">
                  <span>Min: </span><br/>
                  <span class="font-weight-bold">{{formatDisplayNumber(selectedLimits.minSI)}}</span>
                </v-flex>
                <v-flex xs8>
                  <v-text-field box v-num-mask v-model="selectedAmt" label="UOM Value" type="tel" :error-messages="errors.collect('selectedAmt')" data-vv-name="selectedAmt" data-vv-as="UOM Value" v-validate="{ required: true, mask_decimal:2,  mask_min_value: selectedLimits.minSI, mask_max_value: selectedLimits.maxSI, pkg_opt_cvr: [selectedLimits.minSI, selectedLimits.incSI] }" v-if="adjDialog"></v-text-field>
                </v-flex>
                <v-flex xs2 class="pa-2">
                  <span>Max: </span><br/>
                  <span class="font-weight-bold">{{formatDisplayNumber(selectedLimits.maxSI)}}</span>
                </v-flex>
              </v-layout>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat="flat" @click.native="adjDialog = false">Cancel</v-btn>
            <v-btn color="primary" flat="flat" @click.native="doAdjust">Adjust</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <loader v-else :height="300" :init="doInit" loadText="Calculating Adjustment" errorText="Failed to Calculate Adjustment" :loading="packagePlansParam.init === 0" :errorMsgs="packagePlansParam.initErr"></loader>
  </div>
</template>

<script>
import { QUOTE_PACKAGE_ADJ_INIT, QUOTE_PACKAGE_ADJ } from '@/store/types'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number'
import { uomUN } from '@/const/underwriting/package'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      selected: null,
      selectedAmt: null,
      adjDialog: false
    }
  },
  computed: {
    commonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    packagePlansParam() {
      return this.$store.state.agency.quotation.packageParam.reviewPlan
    },
    packageForm() {
      return this.$store.state.agency.quotation.packageForm
    },
    currPrefix() {
      return this.$store.state.agency.quotation.commonInfo.currPrefix
    },
    siAdjustment() {
      if (this.packageForm.siAdjustment) {
        return this.packageForm.siAdjustment
      } else {
        return {}
      }
    },
    selectedLimitText() {
      if (this.selected) {
        const result = this.limitsText.find(x => x.value === this.selected)
        if (result) {
          return result.label
        }
      }
      return ''
    },
    selectedLimits() {
      if (this.plan.limits[this.selected]) {
        return this.plan.limits[this.selected]
      } else {
        return {
          uomAmt: 0,
          minSI: 0,
          maxSI: 0,
          incSI: 1
        }
      }
    }
  },
  methods: {
    async doInit() {
      if (!this.packagePlansParam.adjInit) {
        // Compile all adjustable risk (SI) to an object
        // If there were previous adjustment -> merge
        let siAdjustment = {}
        const limits = this.plan.limits
        if (limits) {
          Object.keys(limits).forEach((key) => {
            const limit = limits[key]
            if (limit && !limit.protSI) {
              if (this.packageForm.siAdjustment && this.packageForm.siAdjustment[key]) {
                Object.assign(siAdjustment, {
                  [key]: this.packageForm.siAdjustment[key]
                })
              } else {
                Object.assign(siAdjustment, {
                  [key]: limit.uomAmt
                })
              }
            }
          })
        }
        this.$store.commit(QUOTE_PACKAGE_ADJ_INIT, siAdjustment)
      }

      if (this.packagePlansParam.init !== 1) {
        // Do a recalculate
        await this.$store.dispatch('packageQuoteRecalculate')
      }
    },
    formatHtml(text) {
      // Replace /r/n with html br
      return text.replace(new RegExp('\\r?\\n', 'g'), '<br />')
    },
    formatDisplayNumber(xNum, scale = 2) {
      return formatDisplayNumber(xNum, scale)
    },
    doEdit(id) {
      this.selected = id
      if (this.siAdjustment[id]) {
        this.selectedAmt = this.siAdjustment[id]
      } else {
        this.selectedAmt = this.selectedLimits.uomAmt
      }
      this.adjDialog = true
    },
    doAdjust() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit(QUOTE_PACKAGE_ADJ, {
            id: this.selected,
            value: Number(removeFormatNumber(this.selectedAmt))
          })
          this.adjDialog = false
          // Do a recalculate
          this.$store.dispatch('packageQuoteRecalculate')
        }
      })
    },
    getUomUN(val) {
      if (val && uomUN[val]) {
        return uomUN[val]
      }
      return ''
    },
    doProceed() {
      this.$emit('proceed')
    }
  },
  mounted() {
    this.doInit()
  },
  props: {
    plan: {
      type: Object,
      default: () => { }
    },
    limitsText: {
      type: Array,
      default: () => []
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">
.planAction {
  width: 50px;
}
</style>
